import React from "react";

import { useUserContext } from "src/shared/contexts";

import { AdminShiftSchedule } from "./admin-shift-schedule";
import { VolunteerShiftSchedule } from "./volunteer-shift-schedule";

const ShiftSchedulePage = () => {
  const { isOrganizer } = useUserContext();
  return (
    <>{isOrganizer ? <AdminShiftSchedule /> : <VolunteerShiftSchedule />}</>
  );
};

export default ShiftSchedulePage;
